import React, { useState, useEffect } from 'react';
import { 
  Plus, Search, Edit, Trash2, Eye, User, Users, Mail, Phone, 
  MapPin, Building, Building2, CreditCard, ChevronLeft, ChevronRight, 
  X, AlertCircle, CheckCircle, XCircle, Filter, Download, Upload, 
  Calendar, FileText, DollarSign, TrendingUp, TrendingDown, Clock, 
  Settings, Package, ShoppingBag, Smartphone, Copy, Star, Sparkles,
  Percent, Tag, Boxes, AlertTriangle, Coffee, BarChart3,
  ShoppingCart, LogOut, Menu, FileSpreadsheet, Image as ImageIcon
} from 'lucide-react';
import { 
  solicitudesService, 
  empresasService,
  serviciosService,
  subserviciosService,
  categoriasSolicitudService
} from '../../../services/api';
import useModal from '../../../hooks/useModal';

const SolicitudesView = () => {
  const { notify, confirm, ModalRenderer } = useModal();
  const [activeTab, setActiveTab] = useState('servicios');
  const [servicios, setServicios] = useState([]);
  const [subservicios, setSubservicios] = useState([]);
  const [categorias, setCategorias] = useState([]); // ← AGREGADO
  const [stats, setStats] = useState(null);
  const [statsSubservicios, setStatsSubservicios] = useState(null);
  const [statsCategorias, setStatsCategorias] = useState(null); // ← AGREGADO
  const [loading, setLoading] = useState(true);

  const [showModalServicio, setShowModalServicio] = useState(false);
  const [modalModeServicio, setModalModeServicio] = useState('create');
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);

  const [showModalSubservicio, setShowModalSubservicio] = useState(false);
  const [modalModeSubservicio, setModalModeSubservicio] = useState('create');
  const [subservicioSeleccionado, setSubservicioSeleccionado] = useState(null);

  // ← AGREGADO: Estados para modal de categoría
  const [showModalCategoria, setShowModalCategoria] = useState(false);
  const [modalModeCategoria, setModalModeCategoria] = useState('create');
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [
        resServicios, 
        resStats, 
        resSubservicios, 
        resStatsSubservicios,
        resCategorias,           // ← AGREGADO
        resStatsCategorias       // ← AGREGADO
      ] = await Promise.all([
        serviciosService.getAll({}),
        serviciosService.getStats(),
        subserviciosService.getAll({}),
        subserviciosService.getStats(),
        categoriasSolicitudService.getAll({}),      // ← AGREGADO
        categoriasSolicitudService.getStats()       // ← AGREGADO
      ]);
      
      setServicios(resServicios.data);
      setStats(resStats.data);
      setSubservicios(resSubservicios.data);
      setStatsSubservicios(resStatsSubservicios.data);
      setCategorias(resCategorias.data);           // ← AGREGADO
      setStatsCategorias(resStatsCategorias.data); // ← AGREGADO
    } catch (error) {
      console.error('Error al cargar datos:', error);
      await notify('error', 'Error', 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Modulo gestion de Servicios, Subservicios y Categorías</h2>
        <p className="text-gray-600">Gestión de Servicios, Subservicios y Categorías</p>
      </div>

      {/* Estadísticas */}
      {stats && statsSubservicios && statsCategorias && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Total Servicios</p>
                <p className="text-2xl font-bold text-gray-800">{stats.total}</p>
              </div>
              <Package className="text-blue-500" size={32} />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Total Subservicios</p>
                <p className="text-2xl font-bold text-gray-800">{statsSubservicios.total}</p>
              </div>
              <Boxes className="text-purple-500" size={32} />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Total Categorías</p>
                <p className="text-2xl font-bold text-gray-800">{statsCategorias.total}</p>
              </div>
              <Tag className="text-green-500" size={32} />
            </div>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div className="bg-white rounded-lg shadow mb-4">
        <div className="flex border-b">
          <button
            onClick={() => setActiveTab('servicios')}
            className={`px-6 py-4 font-medium transition ${
              activeTab === 'servicios'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <div className="flex items-center gap-2">
              <Package size={20} />
              <span>Servicios</span>
              <span className="bg-gray-100 px-2 py-0.5 rounded text-xs">
                {stats?.total || 0}
              </span>
            </div>
          </button>
          <button
            onClick={() => setActiveTab('subservicios')}
            className={`px-6 py-4 font-medium transition ${
              activeTab === 'subservicios'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <div className="flex items-center gap-2">
              <Boxes size={20} />
              <span>Subservicios</span>
              <span className="bg-gray-100 px-2 py-0.5 rounded text-xs">
                {statsSubservicios?.total || 0}
              </span>
            </div>
          </button>
          <button
            onClick={() => setActiveTab('categorias')}
            className={`px-6 py-4 font-medium transition ${
              activeTab === 'categorias'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <div className="flex items-center gap-2">
              <Tag size={20} />
              <span>Categorías</span>
              <span className="bg-gray-100 px-2 py-0.5 rounded text-xs">
                {statsCategorias?.total || 0}
              </span>
            </div>
          </button>
        </div>
      </div>

      {/* Contenido por Tab */}
      {activeTab === 'servicios' && (
        <ServiciosSolicitudTab
          servicios={servicios}
          loading={loading}
          onNuevo={() => {
            setModalModeServicio('create');
            setServicioSeleccionado(null);
            setShowModalServicio(true);
          }}
          onEditar={(srv) => {
            setModalModeServicio('edit');
            setServicioSeleccionado(srv);
            setShowModalServicio(true);
          }}
          onVer={(srv) => {
            setModalModeServicio('view');
            setServicioSeleccionado(srv);
            setShowModalServicio(true);
          }}
          onEliminar={async (id) => {
            const ok = await confirm('Eliminar servicio', '¿Eliminar este servicio?');
            if (!ok) return;
            try {
              await serviciosService.delete(id);
              await notify('success', 'Éxito', 'Servicio eliminado exitosamente');
              cargarDatos();
            } catch (error) {
              await notify('error', 'Error', error.response?.data?.message || 'Error al eliminar');
            }
          }}
        />
      )}

      {activeTab === 'subservicios' && (
        <SubserviciosSolicitudTab
          subservicios={subservicios}
          loading={loading}
          onNuevo={() => {
            setModalModeSubservicio('create');
            setSubservicioSeleccionado(null);
            setShowModalSubservicio(true);
          }}
          onEditar={(sub) => {
            setModalModeSubservicio('edit');
            setSubservicioSeleccionado(sub);
            setShowModalSubservicio(true);
          }}
          onVer={(sub) => {
            setModalModeSubservicio('view');
            setSubservicioSeleccionado(sub);
            setShowModalSubservicio(true);
          }}
          onEliminar={async (id) => {
            const ok = await confirm('Eliminar subservicio', '¿Eliminar este subservicio?');
            if (!ok) return;
            try {
              await subserviciosService.delete(id);
              await notify('success', 'Éxito', 'Subservicio eliminado exitosamente');
              cargarDatos();
            } catch (error) {
              await notify('error', 'Error', error.response?.data?.message || 'Error al eliminar');
            }
          }}
        />
      )}

      {/* ← AGREGADO: Tab de Categorías */}
      {activeTab === 'categorias' && (
        <CategoriasSolicitudTab
          categorias={categorias}
          loading={loading}
          onNuevo={() => {
            setModalModeCategoria('create');
            setCategoriaSeleccionada(null);
            setShowModalCategoria(true);
          }}
          onEditar={(cat) => {
            setModalModeCategoria('edit');
            setCategoriaSeleccionada(cat);
            setShowModalCategoria(true);
          }}
          onVer={(cat) => {
            setModalModeCategoria('view');
            setCategoriaSeleccionada(cat);
            setShowModalCategoria(true);
          }}
          onEliminar={async (id) => {
            const ok = await confirm('Eliminar categoría', '¿Eliminar esta categoría?');
            if (!ok) return;
            try {
              await categoriasSolicitudService.delete(id);
              await notify('success', 'Éxito', 'Categoría eliminada exitosamente');
              cargarDatos();
            } catch (error) {
              await notify('error', 'Error', error.response?.data?.message || 'Error al eliminar');
            }
          }}
        />
      )}

      {/* Modal de Servicio */}
      {showModalServicio && (
        <ServicioSolicitudModal
          mode={modalModeServicio}
          servicio={servicioSeleccionado}
          onClose={() => {
            setShowModalServicio(false);
            setServicioSeleccionado(null);
          }}
          onSuccess={() => {
            setShowModalServicio(false);
            setServicioSeleccionado(null);
            cargarDatos();
          }}
        />
      )}

      {/* Modal de Subservicio */}
      {showModalSubservicio && (
        <SubservicioSolicitudModal
          mode={modalModeSubservicio}
          subservicio={subservicioSeleccionado}
          onClose={() => {
            setShowModalSubservicio(false);
            setSubservicioSeleccionado(null);
          }}
          onSuccess={() => {
            setShowModalSubservicio(false);
            setSubservicioSeleccionado(null);
            cargarDatos();
          }}
        />
      )}

      {/* ← AGREGADO: Modal de Categoría */}
      {showModalCategoria && (
        <CategoriaSolicitudModal
          mode={modalModeCategoria}
          categoria={categoriaSeleccionada}
          onClose={() => {
            setShowModalCategoria(false);
            setCategoriaSeleccionada(null);
          }}
          onSuccess={() => {
            setShowModalCategoria(false);
            setCategoriaSeleccionada(null);
            cargarDatos();
          }}
        />
      )}
      {ModalRenderer}
    </div>
  );
};

// ==================== TAB DE SERVICIOS ====================
const ServiciosSolicitudTab = ({ servicios, loading, onNuevo, onEditar, onVer, onEliminar }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filtrados, setFiltrados] = useState(servicios);

  useEffect(() => {
    if (searchTerm) {
      setFiltrados(
        servicios.filter(s =>
          s.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (s.descripcion && s.descripcion.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      );
    } else {
      setFiltrados(servicios);
    }
  }, [searchTerm, servicios]);

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <p className="text-gray-600">Cargando servicios...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Buscar servicios..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 max-w-md px-4 py-2 border border-gray-300 rounded-lg"
        />
        <button
          onClick={onNuevo}
          className="ml-4 bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
        >
          <Plus size={20} /> Nuevo Servicio
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {filtrados.map((srv) => (
          <div
            key={srv.id}
            className="bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition border-l-4"
            style={{ borderColor: srv.color }}
          >
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center gap-3">
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${srv.color}20` }}
                >
                  <Package size={24} style={{ color: srv.color }} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-lg">{srv.nombre}</h3>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <span
                className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                  srv.activo
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                }`}
              >
                {srv.activo ? 'Activo' : 'Inactivo'}
              </span>
            </div>

            {srv.descripcion && (
              <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                {srv.descripcion}
              </p>
            )}

            <div className="flex gap-2 pt-3 border-t">
<button
  onClick={() => onVer(srv)}
  className="group flex-1 text-blue-600 hover:bg-blue-50 px-3 py-2 rounded text-sm flex items-center justify-center transition-all duration-300"
>
  <Eye size={16} />
  <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-300 ease-in-out group-hover:max-w-xs group-hover:opacity-100 group-hover:ml-1 group-focus:max-w-xs group-focus:opacity-100 group-focus:ml-1">
    Ver
  </span>
</button>

<button
  onClick={() => onEditar(srv)}
  className="group flex-1 text-green-600 hover:bg-green-50 px-3 py-2 rounded text-sm flex items-center justify-center transition-all duration-300"
>
  <Edit size={16} />
  <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-300 ease-in-out group-hover:max-w-xs group-hover:opacity-100 group-hover:ml-1 group-focus:max-w-xs group-focus:opacity-100 group-focus:ml-1">
    Editar
  </span>
</button>

<button
  onClick={() => onEliminar(srv.id)}
  className="group flex-1 text-red-600 hover:bg-red-50 px-3 py-2 rounded text-sm flex items-center justify-center transition-all duration-300"
>
  <Trash2 size={16} />
  <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-300 ease-in-out group-hover:max-w-xs group-hover:opacity-100 group-hover:ml-1 group-focus:max-w-xs group-focus:opacity-100 group-focus:ml-1">
    Eliminar
  </span>
</button>
            </div>
          </div>
        ))}
      </div>

      {filtrados.length === 0 && (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <Package size={64} className="mx-auto text-gray-400 mb-4" />
          <p className="text-gray-600">No se encontraron servicios</p>
        </div>
      )}
    </div>
  );
};

// ==================== TAB DE SUBSERVICIOS ====================
const SubserviciosSolicitudTab = ({ subservicios, loading, onNuevo, onEditar, onVer, onEliminar }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filtrados, setFiltrados] = useState(subservicios);

  useEffect(() => {
    if (searchTerm) {
      setFiltrados(
        subservicios.filter(s =>
          s.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (s.descripcion && s.descripcion.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      );
    } else {
      setFiltrados(subservicios);
    }
  }, [searchTerm, subservicios]);

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <p className="text-gray-600">Cargando subservicios...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Buscar subservicios..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 max-w-md px-4 py-2 border border-gray-300 rounded-lg"
        />
        <button
          onClick={onNuevo}
          className="ml-4 bg-purple-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-purple-700"
        >
          <Plus size={20} /> Nuevo Subservicio
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {filtrados.map((sub) => (
          <div
            key={sub.id}
            className="bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition border-l-4"
            style={{ borderColor: sub.color }}
          >
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center gap-3">
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${sub.color}20` }}
                >
                  <Boxes size={24} style={{ color: sub.color }} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-lg">{sub.nombre}</h3>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <span
                className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                  sub.activo
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                }`}
              >
                {sub.activo ? 'Activo' : 'Inactivo'}
              </span>
            </div>

            {sub.descripcion && (
              <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                {sub.descripcion}
              </p>
            )}

            <div className="flex gap-2 pt-3 border-t">
              <button
                onClick={() => onVer(sub)}
                className="flex-1 text-blue-600 hover:bg-blue-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
              >
                <Eye size={16} /> Ver
              </button>
              <button
                onClick={() => onEditar(sub)}
                className="flex-1 text-green-600 hover:bg-green-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
              >
                <Edit size={16} /> Editar
              </button>
              <button
                onClick={() => onEliminar(sub.id)}
                className="flex-1 text-red-600 hover:bg-red-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
              >
                <Trash2 size={16} /> Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>

      {filtrados.length === 0 && (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <Boxes size={64} className="mx-auto text-gray-400 mb-4" />
          <p className="text-gray-600">No se encontraron subservicios</p>
        </div>
      )}
    </div>
  );
};

// ==================== MODAL DE SERVICIO ====================
const ServicioSolicitudModal = ({ mode, servicio, onClose, onSuccess }) => {
  const { notify, ModalRenderer } = useModal();
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    color: '#3B82F6',
    activo: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const coloresPredefinidos = [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
    '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'
  ];

  useEffect(() => {
    if (servicio) {
      setFormData({
        nombre: servicio.nombre || '',
        descripcion: servicio.descripcion || '',
        color: servicio.color || '#3B82F6',
        activo: servicio.activo !== undefined ? servicio.activo : true
      });
    }
  }, [servicio]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (mode === 'create') {
        await serviciosService.create(formData);
        await notify('success', 'Éxito', 'Servicio creado exitosamente');
      } else if (mode === 'edit') {
        await serviciosService.update(servicio.id, formData);
        await notify('success', 'Éxito', 'Servicio actualizado exitosamente');
      }
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar servicio');
    } finally {
      setLoading(false);
    }
  };

  const isViewMode = mode === 'view';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 sticky top-0 bg-white">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold text-gray-800">
              {mode === 'create' && '🆕 Nuevo Servicio'}
              {mode === 'edit' && '✏️ Editar Servicio'}
              {mode === 'view' && '👁️ Detalles del Servicio'}
            </h3>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="space-y-4">
            {/* Nombre */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Nombre del Servicio <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                disabled={isViewMode}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                placeholder="Ej: COT, Dev, 3D, Automation..."
              />
            </div>

            {/* Descripción */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Descripción
              </label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                disabled={isViewMode}
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                placeholder="Describe el tipo de actividad económica de este servicio..."
              />
              <p className="text-xs text-gray-500 mt-1">
                {formData.descripcion?.length || 0} caracteres
              </p>
            </div>

            {/* Color */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Color de Identificación
              </label>
              <div className="flex gap-3 items-center">
                {coloresPredefinidos.map(color => (
                  <button
                    key={color}
                    type="button"
                    onClick={() => !isViewMode && setFormData(prev => ({ ...prev, color }))}
                    disabled={isViewMode}
                    className={`w-10 h-10 rounded-lg border-2 transition ${
                      formData.color === color 
                        ? 'border-gray-800 scale-110 shadow-lg' 
                        : 'border-gray-300 hover:scale-105'
                    }`}
                    style={{ backgroundColor: color }}
                    title={color}
                  />
                ))}
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    name="color"
                    value={formData.color}
                    onChange={handleChange}
                    disabled={isViewMode}
                    className="w-10 h-10 rounded cursor-pointer"
                  />
                  <span className="text-sm text-gray-600 font-mono">
                    {formData.color}
                  </span>
                </div>
              </div>
            </div>

            {/* Estado Activo */}
            {mode === 'edit' && (
              <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                <input
                  type="checkbox"
                  name="activo"
                  checked={formData.activo}
                  onChange={handleChange}
                  className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label className="ml-3 text-gray-700 font-medium">
                  Servicio Activo
                </label>
                <p className="ml-auto text-xs text-gray-500">
                  {formData.activo ? '✅ Visible' : '❌ Oculto'}
                </p>
              </div>
            )}

            {/* Info adicional en modo vista */}
            {isViewMode && servicio && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar size={18} />
                  Información del Sistema
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <p className="text-gray-600">ID:</p>
                    <p className="font-semibold">{servicio.id}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Creado por:</p>
                    <p className="font-semibold">{servicio.creador_nombre || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Fecha de creación:</p>
                    <p className="font-semibold">
                      {new Date(servicio.created_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-600">Última actualización:</p>
                    <p className="font-semibold">
                      {new Date(servicio.updated_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 flex justify-end gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
          >
            {isViewMode ? 'Cerrar' : 'Cancelar'}
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
              className={`px-6 py-2 rounded-lg text-white transition ${
                loading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-blue-600 hover:bg-blue-700'
              }`}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin">⏳</span>
                  Guardando...
                </span>
              ) : (
                'Guardar'
              )}
            </button>
          )}
        </div>
      </div>
      {ModalRenderer}
    </div>
  );
};


// ==================== MODAL DE SUBSERVICIO ====================
const SubservicioSolicitudModal = ({ mode, subservicio, onClose, onSuccess }) => {
  const { notify, ModalRenderer } = useModal();
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    color: '#8B5CF6',
    activo: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const coloresPredefinidos = [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
    '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'
  ];

  useEffect(() => {
    if (subservicio) {
      setFormData({
        nombre: subservicio.nombre || '',
        descripcion: subservicio.descripcion || '',
        color: subservicio.color || '#8B5CF6',
        activo: subservicio.activo !== undefined ? subservicio.activo : true
      });
    }
  }, [subservicio]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (mode === 'create') {
        await subserviciosService.create(formData);
        await notify('success', 'Éxito', 'Subservicio creado exitosamente');
      } else if (mode === 'edit') {
        await subserviciosService.update(subservicio.id, formData);
        await notify('success', 'Éxito', 'Subservicio actualizado exitosamente');
      }
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar subservicio');
    } finally {
      setLoading(false);
    }
  };

  const isViewMode = mode === 'view';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 sticky top-0 bg-white">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold text-gray-800">
              {mode === 'create' && '🆕 Nuevo Subservicio'}
              {mode === 'edit' && '✏️ Editar Subservicio'}
              {mode === 'view' && '👁️ Detalles del Subservicio'}
            </h3>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="space-y-4">
            {/* Nombre */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Nombre del Subservicio <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                disabled={isViewMode}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 disabled:bg-gray-100"
                placeholder="Ej: Consultoría, Capacitación, Soporte..."
              />
            </div>

            {/* Descripción */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Descripción
              </label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                disabled={isViewMode}
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 disabled:bg-gray-100"
                placeholder="Describe el tipo de subservicio..."
              />
              <p className="text-xs text-gray-500 mt-1">
                {formData.descripcion?.length || 0} caracteres
              </p>
            </div>

            {/* Color */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Color de Identificación
              </label>
              <div className="flex gap-3 items-center">
                {coloresPredefinidos.map(color => (
                  <button
                    key={color}
                    type="button"
                    onClick={() => !isViewMode && setFormData(prev => ({ ...prev, color }))}
                    disabled={isViewMode}
                    className={`w-10 h-10 rounded-lg border-2 transition ${
                      formData.color === color 
                        ? 'border-gray-800 scale-110 shadow-lg' 
                        : 'border-gray-300 hover:scale-105'
                    }`}
                    style={{ backgroundColor: color }}
                    title={color}
                  />
                ))}
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    name="color"
                    value={formData.color}
                    onChange={handleChange}
                    disabled={isViewMode}
                    className="w-10 h-10 rounded cursor-pointer"
                  />
                  <span className="text-sm text-gray-600 font-mono">
                    {formData.color}
                  </span>
                </div>
              </div>
            </div>

            {/* Estado Activo */}
            {mode === 'edit' && (
              <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                <input
                  type="checkbox"
                  name="activo"
                  checked={formData.activo}
                  onChange={handleChange}
                  className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                />
                <label className="ml-3 text-gray-700 font-medium">
                  Subservicio Activo
                </label>
                <p className="ml-auto text-xs text-gray-500">
                  {formData.activo ? '✅ Visible' : '❌ Oculto'}
                </p>
              </div>
            )}

            {/* Info adicional en modo vista */}
            {isViewMode && subservicio && (
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mt-4">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar size={18} />
                  Información del Sistema
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <p className="text-gray-600">ID:</p>
                    <p className="font-semibold">{subservicio.id}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Creado por:</p>
                    <p className="font-semibold">{subservicio.creador_nombre || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Fecha de creación:</p>
                    <p className="font-semibold">
                      {new Date(subservicio.created_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-600">Última actualización:</p>
                    <p className="font-semibold">
                      {new Date(subservicio.updated_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 flex justify-end gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
          >
            {isViewMode ? 'Cerrar' : 'Cancelar'}
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
              className={`px-6 py-2 rounded-lg text-white transition ${
                loading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-purple-600 hover:bg-purple-700'
              }`}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin">⏳</span>
                  Guardando...
                </span>
              ) : (
                'Guardar'
              )}
            </button>
          )}
        </div>
      </div>
      {ModalRenderer}
    </div>
  );
};

// ==================== TAB DE CATEGORÍAS ====================
const CategoriasSolicitudTab = ({ categorias, loading, onNuevo, onEditar, onVer, onEliminar }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filtrados, setFiltrados] = useState(categorias);

  useEffect(() => {
    if (searchTerm) {
      setFiltrados(
        categorias.filter(c =>
          c.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (c.descripcion && c.descripcion.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      );
    } else {
      setFiltrados(categorias);
    }
  }, [searchTerm, categorias]);

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <p className="text-gray-600">Cargando categorías...</p>
      </div>
    );
  }

  // Mapeo de iconos de Lucide React
  const getIconComponent = (iconName) => {
    const iconMap = {
      'Coffee': Coffee,
      'Truck': Package,
      'TrendingUp': TrendingUp,
      'ShoppingBag': ShoppingBag,
      'Package': Package,
      'FileText': FileText,
      'Wrench': Package,
      'Send': Package,
      'Zap': Package,
      'DollarSign': DollarSign,
      'Home': Building,
      'ShoppingCart': ShoppingCart,
      'Users': Users,
      'PartyPopper': Star,
      'Tool': Package,
      'Box': Package,
      'Activity': BarChart3,
      'Receipt': FileText,
      'Wallet': DollarSign,
      'Briefcase': Package,
      'Hotel': Building,
      'RotateCcw': Package,
      'Tag': Tag
    };
    return iconMap[iconName] || Tag;
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Buscar categorías..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 max-w-md px-4 py-2 border border-gray-300 rounded-lg"
        />
        <button
          onClick={onNuevo}
          className="ml-4 bg-green-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-green-700"
        >
          <Plus size={20} /> Nueva Categoría
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {filtrados.map((cat) => {
          const IconComponent = getIconComponent(cat.icono);
          
          return (
            <div
              key={cat.id}
              className="bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition border-l-4"
              style={{ borderColor: cat.color }}
            >
              <div className="flex justify-between items-start mb-3">
                <div className="flex items-center gap-3">
                  <div
                    className="w-12 h-12 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${cat.color}20` }}
                  >
                    <IconComponent size={24} style={{ color: cat.color }} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 text-lg">{cat.nombre}</h3>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <span
                  className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                    cat.activo
                      ? 'bg-green-100 text-green-800'
                      : 'bg-red-100 text-red-800'
                  }`}
                >
                  {cat.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>

              {cat.descripcion && (
                <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                  {cat.descripcion}
                </p>
              )}

              <div className="flex gap-2 pt-3 border-t">
                <button
                  onClick={() => onVer(cat)}
                  className="flex-1 text-blue-600 hover:bg-blue-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
                >
                  <Eye size={16} /> Ver
                </button>
                <button
                  onClick={() => onEditar(cat)}
                  className="flex-1 text-green-600 hover:bg-green-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
                >
                  <Edit size={16} /> Editar
                </button>
                <button
                  onClick={() => onEliminar(cat.id)}
                  className="flex-1 text-red-600 hover:bg-red-50 px-3 py-2 rounded text-sm flex items-center justify-center gap-1"
                >
                  <Trash2 size={16} /> Eliminar
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {filtrados.length === 0 && (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <Tag size={64} className="mx-auto text-gray-400 mb-4" />
          <p className="text-gray-600">No se encontraron categorías</p>
        </div>
      )}
    </div>
  );
};

// ==================== MODAL DE CATEGORÍA ====================
const CategoriaSolicitudModal = ({ mode, categoria, onClose, onSuccess }) => {
  const { notify, ModalRenderer } = useModal();
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    color: '#3B82F6',
    icono: 'Tag',
    activo: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const coloresPredefinidos = [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
    '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16',
    '#F97316', '#14B8A6', '#6366F1', '#DC2626'
  ];

  const iconosPredefinidos = [
    { name: 'Tag', label: 'Etiqueta' },
    { name: 'Coffee', label: 'Café' },
    { name: 'Truck', label: 'Camión' },
    { name: 'TrendingUp', label: 'Tendencia' },
    { name: 'ShoppingBag', label: 'Bolsa' },
    { name: 'Package', label: 'Paquete' },
    { name: 'FileText', label: 'Documento' },
    { name: 'DollarSign', label: 'Dinero' },
    { name: 'Home', label: 'Casa' },
    { name: 'ShoppingCart', label: 'Carrito' },
    { name: 'Users', label: 'Usuarios' },
    { name: 'Star', label: 'Estrella' },
    { name: 'Activity', label: 'Actividad' },
    { name: 'Briefcase', label: 'Maletín' },
    { name: 'Receipt', label: 'Recibo' },
    { name: 'Wallet', label: 'Billetera' }
  ];

  useEffect(() => {
    if (categoria) {
      setFormData({
        nombre: categoria.nombre || '',
        descripcion: categoria.descripcion || '',
        color: categoria.color || '#3B82F6',
        icono: categoria.icono || 'Tag',
        activo: categoria.activo !== undefined ? categoria.activo : true
      });
    }
  }, [categoria]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (mode === 'create') {
        await categoriasSolicitudService.create(formData);
        await notify('success', 'Éxito', 'Categoría creada exitosamente');
      } else if (mode === 'edit') {
        await categoriasSolicitudService.update(categoria.id, formData);
        await notify('success', 'Éxito', 'Categoría actualizada exitosamente');
      }
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar categoría');
    } finally {
      setLoading(false);
    }
  };

  const isViewMode = mode === 'view';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 sticky top-0 bg-white">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold text-gray-800">
              {mode === 'create' && '🆕 Nueva Categoría'}
              {mode === 'edit' && '✏️ Editar Categoría'}
              {mode === 'view' && '👁️ Detalles de la Categoría'}
            </h3>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="space-y-4">
            {/* Nombre */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Nombre de la Categoría <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                disabled={isViewMode}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 disabled:bg-gray-100"
                placeholder="Ej: Viático, Fletes, Mejora..."
              />
            </div>

            {/* Descripción */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Descripción
              </label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                disabled={isViewMode}
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 disabled:bg-gray-100"
                placeholder="Describe el propósito de esta categoría..."
              />
              <p className="text-xs text-gray-500 mt-1">
                {formData.descripcion?.length || 0} caracteres
              </p>
            </div>

            {/* Icono */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Icono
              </label>
              <select
                name="icono"
                value={formData.icono}
                onChange={handleChange}
                disabled={isViewMode}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 disabled:bg-gray-100"
              >
                {iconosPredefinidos.map(icono => (
                  <option key={icono.name} value={icono.name}>
                    {icono.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Color */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Color de Identificación
              </label>
              <div className="flex gap-3 items-center flex-wrap">
                {coloresPredefinidos.map(color => (
                  <button
                    key={color}
                    type="button"
                    onClick={() => !isViewMode && setFormData(prev => ({ ...prev, color }))}
                    disabled={isViewMode}
                    className={`w-10 h-10 rounded-lg border-2 transition ${
                      formData.color === color 
                        ? 'border-gray-800 scale-110 shadow-lg' 
                        : 'border-gray-300 hover:scale-105'
                    }`}
                    style={{ backgroundColor: color }}
                    title={color}
                  />
                ))}
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    name="color"
                    value={formData.color}
                    onChange={handleChange}
                    disabled={isViewMode}
                    className="w-10 h-10 rounded cursor-pointer"
                  />
                  <span className="text-sm text-gray-600 font-mono">
                    {formData.color}
                  </span>
                </div>
              </div>
            </div>

            {/* Estado Activo */}
            {mode === 'edit' && (
              <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                <input
                  type="checkbox"
                  name="activo"
                  checked={formData.activo}
                  onChange={handleChange}
                  className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
                />
                <label className="ml-3 text-gray-700 font-medium">
                  Categoría Activa
                </label>
                <p className="ml-auto text-xs text-gray-500">
                  {formData.activo ? '✅ Visible' : '❌ Oculta'}
                </p>
              </div>
            )}

            {/* Info adicional en modo vista */}
            {isViewMode && categoria && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-4">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar size={18} />
                  Información del Sistema
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <p className="text-gray-600">ID:</p>
                    <p className="font-semibold">{categoria.id}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Creado por:</p>
                    <p className="font-semibold">{categoria.creador_nombre || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Fecha de creación:</p>
                    <p className="font-semibold">
                      {new Date(categoria.created_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-600">Última actualización:</p>
                    <p className="font-semibold">
                      {new Date(categoria.updated_at).toLocaleDateString('es-ES')}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 flex justify-end gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
          >
            {isViewMode ? 'Cerrar' : 'Cancelar'}
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
              className={`px-6 py-2 rounded-lg text-white transition ${
                loading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-green-600 hover:bg-green-700'
              }`}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin">⏳</span>
                  Guardando...
                </span>
              ) : (
                'Guardar'
              )}
            </button>
          )}
        </div>
      </div>
      {ModalRenderer}
    </div>
  );
};



export default SolicitudesView;